<template>
  <div id="contactTypeForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-select label="Choose from a predefined configuration" @change="changePreset" v-model="selectedPreset" :items="presetNames"/>
      <v-text-field v-model="contactType.name" label="Name" :required="true" />
      <v-text-field
        v-model="contactType.description"
        label="Description"
        :required="false"
      />
      <v-radio-group v-model="type" row>
        <template v-slot:label>
          <div>Type</div>
        </template>
        <v-radio value="Customer">
          <template v-slot:label>
            <div>Customer</div>
          </template>
        </v-radio>
        <v-radio value="Staff">
          <template v-slot:label>
            <div>Staff</div>
          </template>
        </v-radio>
        <v-radio value="Visitor">
          <template v-slot:label>
            <div>Visitor</div>
          </template>
        </v-radio>
        <v-radio value="Other">
          <template v-slot:label>
            <div>Other</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_student" row>
        <template v-slot:label>
          <div>Has Student</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_teacher" row>
        <template v-slot:label>
          <div>Has Teacher</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_ledger" row>
        <template v-slot:label>
          <div>Has Ledger</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_appointment" row>
        <template v-slot:label>
          <div>Has Appointment</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_notes" row>
        <template v-slot:label>
          <div>Has Notes</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_calls" row>
        <template v-slot:label>
          <div>Has Calls</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_email" row>
        <template v-slot:label>
          <div>Has Emails</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_sms" row>
        <template v-slot:label>
          <div>Has SMS</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_inquiry" row>
        <template v-slot:label>
          <div>Has Inquiry</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_group" row>
        <template v-slot:label>
          <div>Has Group</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_attachment" row>
        <template v-slot:label>
          <div>Has Attachment</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>

      <v-radio-group v-model="contactType.has_car" row>
        <template v-slot:label>
          <div>Has Car</div>
        </template>
        <v-radio :value="true">
          <template v-slot:label>
            <div>Yes</div>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template v-slot:label>
            <div>No</div>
          </template>
        </v-radio>
      </v-radio-group>
      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>

<script>
import { getContactType } from "@/services/contactType";

import { mapActions } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      type: 'Other',
      contactType: {
        relations: {},
        name: "",
        description: "",
        is_staff: null,
        is_customer: null,
        is_visitor: null,
        has_student: null,
        has_teacher: null,
        has_ledger: null,
        has_appointment: null,
        has_notes: null,
        has_calls: null,
        has_email: null,
        has_sms: null,
        has_inquiry: null,
        has_group: null,
        has_attachment: null,
        has_car: null
      },
      selectedPreset: null,
      preset: {
        Customer: {
          is_staff: false,
          is_customer: true,
          is_visitor: false,
          has_student: true,
          has_teacher: false,
          has_ledger: true,
          has_appointment: true,
          has_notes: true,
          has_calls: false,
          has_email: false,
          has_sms: false,
          has_inquiry: true,
          has_group: true,
          has_attachment: true,
          has_car: false
        },
        Staff: {
          is_staff: true,
          is_customer: false,
          is_visitor: false,
          has_student: false,
          has_teacher: false,
          has_ledger: false,
          has_appointment: true,
          has_notes: true,
          has_calls: false,
          has_email: false,
          has_sms: false,
          has_inquiry: false,
          has_group: false,
          has_attachment: true,
          has_car: false
        },
        Visitor: {
          is_staff: false,
          is_customer: false,
          is_visitor: true,
          has_student: false,
          has_teacher: false,
          has_ledger: false,
          has_appointment: false,
          has_notes: true,
          has_calls: false,
          has_email: false,
          has_sms: false,
          has_inquiry: true,
          has_group: false,
          has_attachment: true,
          has_car: false
        },
        Custom: {
          is_staff: false,
          is_customer: false,
          is_visitor: false,
          has_student: false,
          has_teacher: false,
          has_ledger: false,
          has_appointment: false,
          has_notes: true,
          has_calls: false,
          has_email: false,
          has_sms: false,
          has_inquiry: false,
          has_group: false,
          has_attachment: true,
          has_car: false
        }
      }
    };
  },
  computed: {
    presetNames(){
      return Object.keys(this.preset);
    }
  },
  created() {
    this.setInstance();
  },
  methods: {
    ...mapActions("contactType", ["createContactType", "updateContactType"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),

    async handleSubmit() {
      //set type
      this.assignType();

      if (this.id) {
        let contactType = this.contactType;
        delete contactType.relations;

        this.updateContactType(contactType)
          .then(response => {
            console.log(response);
            this.addSuccessMessage("ContactType was updated successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating ContactType, please try again later"
            );
          });
      } else {
        let contactType = this.contactType;
        delete contactType.relations;

        this.createContactType(contactType)
          .then(response => {
            console.log(response);
            this.addSuccessMessage("ContactType was created successfully");
            this.goBack();
          })
          .catch(() => {
            this.addErrorMessage(
              "Error creating ContactType, please try again later"
            );
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.contactType.id = this.id;
        getContactType(this.id).then(response => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.contactType, property)
            ) {
              this.contactType[property] = instance[property];
            }
          }

          this.initType();
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
    changePreset(){
      if(this.selectedPreset){
        const predefined = this.preset[this.selectedPreset];
        this.contactType = Object.assign(this.contactType, predefined);
        this.type = this.selectedPreset;
      }
    },
    assignType(){
      switch(this.type){
        case 'Customer':
          this.contactType.is_staff = false;
          this.contactType.is_visitor = false;
          this.contactType.is_customer = true;
          break;
        case 'Staff':
          this.contactType.is_staff = true;
          this.contactType.is_visitor = false;
          this.contactType.is_customer = false;
          break;
        case 'Visitor':
          this.contactType.is_staff = false;
          this.contactType.is_visitor = true;
          this.contactType.is_customer = false;
          break;
        default:
          this.contactType.is_staff = false;
          this.contactType.is_visitor = false;
          this.contactType.is_customer = false;
          break;
      }
    },
    initType(){
      if(this.contactType.is_staff){
        this.type = 'Staff'
      }
      else if(this.contactType.is_customer){
        this.type = 'Customer'
      }
      else if(this.contactType.is_visitor){
        this.type = 'Visitor'
      }
      else{
        this.type = 'Other'
      }
    }
  },
  components: {}
};
</script>
